import { DependencyList, EffectCallback, useEffect, useLayoutEffect, useState } from 'react';

export function useWindowResizeEffect(effect: EffectCallback, deps: DependencyList = []) {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    useEffect(effect, [...deps, size[0], size[1]]);
}
